var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowgreenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.993085 12C1.25575 12.0022 1.50881 11.9012 1.69775 11.7187L6.70669 6.70845C6.8945 6.52054 7 6.26571 7 6C7 5.73429 6.8945 5.47946 6.70669 5.29155L1.69774 0.281287C1.50881 0.0987558 1.25575 -0.00224596 0.993085 3.71499e-05C0.730419 0.00232026 0.479157 0.107706 0.293418 0.293495C0.107678 0.479283 0.00231987 0.730611 3.73892e-05 0.993346C-0.00224509 1.25608 0.0987296 1.5092 0.281214 1.69819L4.58189 6L3.58011 7.00205L0.281214 10.3018C0.09873 10.4908 -0.00224468 10.7439 3.78269e-05 11.0067C0.00232033 11.2694 0.107678 11.5207 0.293418 11.7065C0.479158 11.8923 0.730419 11.9977 0.993085 12Z",
    fill: "#009940"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowgreenIcon);
export default __webpack_public_path__ + "static/media/arrowgreen-icon.d6fbb5ba.svg";
export { ForwardRef as ReactComponent };